import React from 'react';

const PerkCard = ({ title, description, variant = 'dark' }) => {
  const variants = {
    dark: 'bg-ifys-blue text-white shadow-sm hover:shadow-lg',
    light: 'bg-ifys-perk-light text-ifys-blue shadow-sm hover:shadow-lg',
  };

  return (
    <div
      className={`${variants[variant]} rounded-2xl p-6 sm:p-7 flex flex-col h-full transition-all duration-300 ease-smooth hover:-translate-y-1`}
    >
      <h3 className="text-xl font-bold mb-4 leading-tight">
        {title}
      </h3>
      <div className="space-y-2 flex-1">
        {description.map((line, index) => (
          <p key={index} className="text-sm leading-relaxed font-light">{line}</p>
        ))}
      </div>
    </div>
  );
};

export default PerkCard;
